// src/theme/win31.ts
import { theme } from 'antd';

export const win31Theme = {
  // 使用浅色算法
  algorithm: theme.defaultAlgorithm,

  // 全局 Design Token
  token: {
    // 主色 – Office 2007 经典蓝（标题栏、按钮主色）
    colorPrimary: '#2A5C8A',
    colorPrimaryHover: '#3D7EB5',
    colorPrimaryActive: '#1D4466',
    colorPrimaryBg: '#D8E4F0',

    // 功能色 – 沿用 Office 2007 风格
    colorSuccess: '#4E8A4E',
    colorWarning: '#C48A3A',
    colorError: '#B84A4A',
    colorInfo: '#2A5C8A',

    // 背景色 – 银灰/米色系
    colorBgBase: '#F0F0F0',
    colorBgContainer: '#FFFFFF',
    colorBgElevated: '#FAFAFA',
    colorBgLayout: '#E6E6E6',      // 类似 Office 背景
    colorBgSpotlight: '#2A5C8A',   // Tooltip 等

    // 文字色 – 深灰/黑
    colorTextBase: '#1E1E1E',
    colorTextSecondary: '#3A3A3A',
    colorTextTertiary: '#6A6A6A',
    colorTextQuaternary: '#9A9A9A',

    // 边框 – 银灰
    colorBorder: '#ADADAD',
    colorBorderSecondary: '#C5C5C5',

    // 圆角 – 中等（Office 2007 略有圆角）
    borderRadius: 4,
    borderRadiusSM: 3,
    borderRadiusLG: 6,
    borderRadiusXS: 2,
    borderRadiusOuter: 4,

    // 字体 – Office 2007 常用字体
    fontFamily: "'Segoe UI', 'Tahoma', 'Verdana', 'Arial', sans-serif",
    fontFamilyCode: "'Consolas', 'Courier New', monospace",

    // 阴影 – 立体感（按钮/弹窗）
    boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
    boxShadowSecondary: '0 1px 3px rgba(0,0,0,0.15)',

    // 控制组件尺寸（标准）
    controlHeight: 32,
    controlHeightSM: 26,
    controlHeightLG: 40,
    controlHeightXS: 22,

    // 间距
    padding: 16,
    paddingSM: 10,
    paddingLG: 20,
    paddingXS: 6,
    margin: 16,
    marginSM: 10,
    marginLG: 20,
    marginXS: 6,

    // 边框宽度
    lineWidth: 1,
    lineWidthBold: 2,

    // 动效 – 保留轻微过渡
    motion: true,
    motionUnit: 0.15,
    motionBase: 0,
  },

  // 组件级定制
  components: {
    // ========== 通用组件 ==========
    Button: {
      borderRadius: 4,
      // Office 2007 立体按钮（渐变+投影）
      primaryShadow: '0 1px 3px rgba(0,0,0,0.3), inset 0 1px 0 rgba(255,255,255,0.3)',
      defaultShadow: '0 1px 3px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.5)',
      defaultBorderColor: '#ADADAD',
      defaultHoverBorderColor: '#2A5C8A',
      defaultHoverColor: '#1E1E1E',
      defaultHoverBg: '#E8F0F8',
      contentFontSize: 14,
      contentFontSizeLG: 16,
      contentFontSizeSM: 12,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      borderColor: '#ADADAD',
      borderWidth: 1,
      fontWeight: 'normal',
      colorPrimaryHover: '#3D7EB5',
      colorPrimaryActive: '#1D4466',
    },

    Layout: {
      headerBg: '#2A5C8A',          // Office 标题栏深蓝
      headerColor: '#FFFFFF',
      headerPadding: '0 16px',
      bodyBg: '#E6E6E6',            // 页面背景灰
      footerBg: '#D6D6D6',
      footerPadding: '8px 16px',
      triggerBg: '#C0C0C0',
      triggerColor: '#1E1E1E',
      triggerHeight: 48,
      zeroTriggerHeight: 48,
    },

    Menu: {
      colorItemBg: 'transparent',
      colorSubItemBg: 'rgba(0,0,0,0.04)',
      colorItemText: '#1E1E1E',
      colorItemTextSelected: '#1E1E1E',
      colorItemBgSelected: '#C0C0C0',
      colorItemBgActive: '#D0D0D0',
      radiusItem: 3,
      controlHeightLG: 32,
      itemMarginInline: 4,
      borderColor: '#ADADAD',
      borderWidth: 1,
    },

    Breadcrumb: {
      colorText: '#3A3A3A',
      colorTextSecondary: '#2A5C8A',
      lastItemColor: '#1E1E1E',
      separatorColor: '#6A6A6A',
    },

    Pagination: {
      borderRadius: 4,
      colorPrimary: '#2A5C8A',
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderWidth: 1,
    },

    Steps: {
      colorPrimary: '#2A5C8A',
      colorText: '#3A3A3A',
      colorTextSecondary: '#6A6A6A',
      colorBgContainer: '#FFFFFF',
      borderRadius: 4,
    },

    Tabs: {
      colorPrimary: '#2A5C8A',
      colorText: '#3A3A3A',
      colorTextActive: '#1E1E1E',
      colorTextHover: '#2A5C8A',
      colorBorder: '#ADADAD',
      cardBg: '#F0F0F0',
      cardGutter: 2,
      horizontalMargin: '0 0 8px 0',
      horizontalItemGutter: 16,
      borderWidth: 1,
    },

    // ========== 数据录入 ==========
    Input: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      colorPrimaryHover: '#2A5C8A',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      activeBg: '#FFFFFF',
      activeBorderColor: '#2A5C8A',
      hoverBorderColor: '#2A5C8A',
      borderWidth: 1,
    },

    Select: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      optionSelectedBg: '#C0C0C0',
      optionActiveBg: '#E0E0E0',
      borderWidth: 1,
    },

    Cascader: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      borderWidth: 1,
    },

    DatePicker: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      cellHeight: 24,
      cellWidth: 32,
      borderWidth: 1,
    },

    TimePicker: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      borderWidth: 1,
    },

    InputNumber: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      borderWidth: 1,
    },

    Checkbox: {
      colorPrimary: '#2A5C8A',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlInteractiveSize: 14,
    },

    Radio: {
      colorPrimary: '#2A5C8A',
      colorBorder: '#ADADAD',
      radioSize: 14,
      dotSize: 6,
    },

    Switch: {
      colorPrimary: '#2A5C8A',
      colorPrimaryHover: '#3D7EB5',
      handleBg: '#FFFFFF',
      handleShadow: '0 1px 2px rgba(0,0,0,0.2)',
      trackHeight: 22,
      trackMinWidth: 40,
      innerMinMargin: 4,
    },

    Slider: {
      colorPrimary: '#2A5C8A',
      colorPrimaryHover: '#3D7EB5',
      colorPrimaryBorder: '#2A5C8A',
      colorPrimaryBorderHover: '#3D7EB5',
      trackBg: '#2A5C8A',
      trackHoverBg: '#3D7EB5',
      handleColor: '#2A5C8A',
      handleSize: 12,
      handleSizeHover: 14,
      dotSize: 6,
    },

    Rate: {
      colorPrimary: '#C48A3A',
      starSize: 18,
      starBg: '#ADADAD',
    },

    Upload: {
      colorPrimary: '#2A5C8A',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      borderWidth: 1,
    },

    Form: {
      labelColor: '#1E1E1E',
      labelFontSize: 14,
      labelHeight: 32,
      itemMarginBottom: 16,
    },

    Mentions: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      borderWidth: 1,
    },

    AutoComplete: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      borderWidth: 1,
    },

    TreeSelect: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 26,
      borderWidth: 1,
    },

    ColorPicker: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      controlHeight: 32,
      borderWidth: 1,
    },

    Transfer: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      listWidth: 180,
      listHeight: 200,
      borderWidth: 1,
    },

    // ========== 数据展示 ==========
    Table: {
      borderColor: '#ADADAD',
      headerBg: '#E0E0E0',          // 表头银灰
      headerColor: '#1E1E1E',
      headerSortActiveBg: '#D0D0D0',
      headerSortHoverBg: '#D0D0D0',
      rowHoverBg: 'rgba(42, 92, 138, 0.08)',
      rowSelectedBg: 'rgba(42, 92, 138, 0.15)',
      rowSelectedHoverBg: 'rgba(42, 92, 138, 0.25)',
      cellPaddingInline: 12,
      cellPaddingBlock: 8,
      borderRadius: 4,
      borderWidth: 1,
    },

    Card: {
      colorBgContainer: '#FFFFFF',
      colorBorderSecondary: '#ADADAD',
      boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      borderRadiusLG: 6,
      padding: 16,
      paddingSM: 12,
      paddingLG: 20,
      headerBg: 'transparent',
      headerFontSize: 16,
      borderWidth: 1,
    },

    List: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      padding: 16,
      paddingSM: 12,
      paddingLG: 20,
      metaMargin: 16,
    },

    Descriptions: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      labelColor: '#3A3A3A',
      titleColor: '#1E1E1E',
      padding: 16,
      paddingSM: 12,
      paddingLG: 20,
      borderRadius: 4,
      borderWidth: 1,
    },

    Avatar: {
      colorBgContainer: '#ADADAD',
      colorText: '#1E1E1E',
      borderRadius: 4,
      borderRadiusLG: 6,
      borderRadiusSM: 3,
      size: 36,
      sizeLG: 48,
      sizeSM: 24,
    },

    Badge: {
      borderRadius: 4,
      colorBgContainer: '#B84A4A',
      colorText: '#FFFFFF',
      dotSize: 8,
      shadowSize: 0,
    },

    Tag: {
      colorBgContainer: '#E8E8E8',
      colorBorder: '#ADADAD',
      colorText: '#1E1E1E',
      borderRadius: 4,
      defaultBg: '#E8E8E8',
      defaultColor: '#1E1E1E',
      borderWidth: 1,
    },

    Popover: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 6,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      padding: 12,
      borderWidth: 1,
    },

    Tooltip: {
      colorBgSpotlight: '#2A5C8A',
      colorTextLightSolid: '#FFFFFF',
      borderRadius: 4,
      fontSize: 12,
      padding: 6,
    },

    Popconfirm: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 6,
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      borderWidth: 1,
    },

    Dropdown: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
      padding: 4,
      borderWidth: 1,
    },

    Tree: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      nodeHoverColor: 'rgba(42, 92, 138, 0.06)',
      nodeSelectedColor: 'rgba(42, 92, 138, 0.12)',
      indentSize: 16,
      borderRadius: 4,
    },

    Calendar: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      fullBg: '#E6E6E6',
      fullPanelBg: '#FFFFFF',
      itemActiveBg: 'rgba(42, 92, 138, 0.12)',
    },

    Statistic: {
      colorBgContainer: '#FFFFFF',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      titleFontSize: 14,
      contentFontSize: 22,
    },

    Comment: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      padding: 16,
    },

    Carousel: {
      colorBgContainer: '#ADADAD',
      colorText: '#1E1E1E',
      dotHeight: 4,
      dotWidth: 16,
    },

    Collapse: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      headerBg: '#F0F0F0',
      borderRadius: 4,
      padding: 12,
      borderWidth: 1,
    },

    Timeline: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      dotBg: '#2A5C8A',
      tailColor: '#ADADAD',
    },

    // ========== 反馈组件 ==========
    Alert: {
      borderRadius: 4,
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      padding: 12,
      paddingSM: 8,
      borderWidth: 1,
    },

    Notification: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 6,
      boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
      padding: 16,
      paddingLG: 20,
      borderWidth: 1,
    },

    Message: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 6,
      boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
      padding: 12,
      borderWidth: 1,
    },

    Modal: {
      borderRadiusLG: 6,
      boxShadow: '0 4px 16px rgba(0,0,0,0.25)',
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      headerBg: '#2A5C8A',          // 标题栏深蓝
      headerColor: '#FFFFFF',
      titleColor: '#FFFFFF',
      titleFontSize: 18,
      padding: 20,
      paddingLG: 24,
      paddingMD: 16,
      paddingXS: 12,
      borderWidth: 1,
    },

    Drawer: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadiusLG: 0,
      boxShadow: '0 2px 10px rgba(0,0,0,0.12)',
      padding: 20,
      titleColor: '#1E1E1E',
      titleFontSize: 18,
      borderWidth: 1,
    },

    Progress: {
      colorBgContainer: '#ADADAD',
      colorText: '#3A3A3A',
      colorTextSecondary: '#6A6A6A',
      defaultColor: '#2A5C8A',
      remainingColor: '#ADADAD',
      borderRadius: 3,
      lineWidth: 8,
    },

    Result: {
      colorBgContainer: '#FFFFFF',
      colorText: '#1E1E1E',
      colorTextSecondary: '#3A3A3A',
      titleFontSize: 24,
      subtitleFontSize: 16,
      iconSize: 48,
    },

    Skeleton: {
      colorBgContainer: '#ADADAD',
      colorText: '#E0E0E0',
      borderRadius: 4,
    },

    Empty: {
      colorBgContainer: 'transparent',
      colorText: '#3A3A3A',
      colorTextSecondary: '#6A6A6A',
    },

    Spin: {
      colorPrimary: '#2A5C8A',
      colorBgContainer: 'rgba(230, 230, 230, 0.6)',
    },

    // ========== 其他 ==========
    Anchor: {
      colorBgContainer: 'transparent',
      colorBorder: '#ADADAD',
      colorText: '#3A3A3A',
      colorTextActive: '#2A5C8A',
      colorTextHover: '#2A5C8A',
    },

    BackTop: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
      borderWidth: 1,
    },

    App: {
      colorBgContainer: '#E6E6E6',
      colorText: '#1E1E1E',
    },

    QRCode: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 4,
      borderWidth: 1,
    },

    Tour: {
      colorBgContainer: '#FFFFFF',
      colorBorder: '#ADADAD',
      borderRadius: 6,
      boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
      borderWidth: 1,
    },
  },
};